<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="diagnostics"
      :loading="loading"
      :page="page"
      :options.sync="options"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.death_cause.name')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.name"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            url="diagnostics"
            typeData="not-delete"
            :resource="item"
            @updateGrid="searchGridData()"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <DeathCause
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, searchGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import { getDiagnostics } from "@/service/basic-registrations/DeathCauseService";
import DeathCause from "./DeathCause.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";
import Formatters from "@/utils/Formatters";

export default {
  components: {
    Menu,
    ChangeStatus,
    DeathCause,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      diagnostics: [],
      loading: false,
      page: 1,
      options: {},
      resource: {},
      headers: [
        { text: 'Causas De Morte Neurológicas', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Ações', value: 'actions', sortable: false },
      ],
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "DeathCause",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.changeActionsData(this.actions);
  },

  mounted() {
    this.searchGridData();
  },

  methods: {
    ...mapActions(["changeActionsData", "changeSnackBarData"]),

    searchGridData() {
      this.loading = true;
      getDiagnostics({
        name: this.filterForm.name || '',
        page: this.page,
        per_page: this.options.itemsPerPage,
      }).then((result) => {
        this.diagnostics = result;
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        this.changeSnackBarData({
          status: true,
          type: 'erro',
          titleMessage: this.$t('messages.something_went_wrong'),
          bodyMessage: Formatters.formatErrorMessage(err.details || err.erro),
          cardColor: 'red',
          titleIcon: 'mdi-close-circle',
        });
        setTimeout(() => {
          this.changeSnackBarData({ status: false, type: '', titleMessage: '', bodyMessage: '', cardColor: '', titleIcon: '' });
        }, 3000);
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    applyFilter() {
      this.searchGridData();
    },

    clearFilter() {
      this.filterForm = {};
      this.searchGridData();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
